module.exports = __webpack_public_path__ + "static/elephanthoodedtowel-a748c7158874f831c27e013ce9d82933.jpeg";